import React from 'react';

const ProfileList = ({ profile }) =>
  <ul className="profile-list fadeInRight animated">

    <li>
      <div className="column-left">会社名</div>
      <div className="column-right">{profile.company}</div>
    </li>
    <li>
      <div className="column-left">役職</div>
      <div className="column-right">{profile.position}</div>
    </li>
    <li>
      <div className="column-left">趣味</div>
      <div className="column-right">{profile.hobbies}</div>
    </li>
    <li>
      <div className="column-left">所在地</div>
      <div className="column-right">{profile.location}</div>
    </li>
    <li>
      <div className="column-left">年齢</div>
      <div className="column-right">{profile.age}</div>
    </li>
  </ul>;

export default ProfileList;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/LockHomeDemo/components/ProfileList.js